import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const TERMS = [
  "Offer valid on GTA 6 purchase made on launch day (June 25, 2026) only.",
  "Limited to first 50 verified buyers. First come, first served.",
  "Discount of 20% up to ₹1,200 will be provided as PSN wallet credit only.",
  "One claim per person. Duplicate entries will be disqualified.",
  "Valid for India residents only.",
  "Proof of purchase (PS Store order screenshot) is mandatory to receive credit.",
  "PSN credit will be dispatched within 48 hours of purchase verification.",
  "Grovefan reserves the right to modify or withdraw this offer at any time.",
  "PSN credit has no cash alternative.",
];

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}

export default function GroveLaunchTermsModal({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Grove Launch Offer — Terms &amp; Conditions</DialogTitle>
        </DialogHeader>
        <ol className="max-h-[60vh] list-decimal space-y-2 overflow-y-auto pl-5 pr-2 text-sm text-foreground/90">
          {TERMS.map((t, i) => <li key={i}>{t}</li>)}
        </ol>
      </DialogContent>
    </Dialog>
  );
}
